import { IValueValidation } from "client/Validation/input";
import { getDataUrl } from "client/Misc/utils";
import { IValueReducer } from "../reducer";
import { NewValueHandler } from "./misc";
import { Base64FileUriUploadWithMetadataModel, fileMetadataSymbol } from "client/Misc/commonTypes";

export interface IAttachableFileSelectorProps {
	readonly trackingId: string;
	onChange(newValue: File): void;
}

export interface IAttachableFileSelectorPropsWithBuilder extends IAttachableFileSelectorProps {
	withOnChange(handler: (newValue: File) => void): IAttachableFileSelectorPropsWithBuilder;
}

export class AttachableFileSelectorPropsWithBuilder implements IAttachableFileSelectorPropsWithBuilder {
	private readonly _reducer: IValueReducer<OptionalModel<Base64FileUriUploadWithMetadataModel | null>>;
	private readonly _validation: IValueValidation<OptionalModel<Base64FileUriUploadWithMetadataModel>>;
	private readonly _extraOnChangeHandlers: NewValueHandler<File>[];

	public readonly trackingId: string;

	constructor (
		reducer: IValueReducer<OptionalModel<Base64FileUriUploadWithMetadataModel | null>>,
		validation: IValueValidation<OptionalModel<Base64FileUriUploadWithMetadataModel>>
	) {
		this._reducer = reducer;
		this._validation = validation;
		this._extraOnChangeHandlers = [];

		this.trackingId = reducer.path;

		this.onChange = this.onChange.bind(this);
		this.withOnChange = this.withOnChange.bind(this);
	}

	public withOnChange(handler: (newValue: File) => void): IAttachableFileSelectorPropsWithBuilder {
		this._extraOnChangeHandlers.push(handler);
		return this;
	}

	public onChange(selectedFile: File): void {
		getDataUrl(selectedFile)
			.then(
				uri => {
					this._reducer.setValue({
						isSet: true,
						value: {
							uri,
							filename: selectedFile.name,
							[fileMetadataSymbol]: {
								size: selectedFile.size,
								mimeType: selectedFile.type
							}
						}
					});

					this._validation.triggerInputFinished();
				}
			);


		for (const handler of this._extraOnChangeHandlers) {
			handler(selectedFile);
		}
	}
}